import { fmtDate } from './planningApi';
import { lessonParts } from './lessonLabels';

const esc = (s) => String(s ?? '').replace(/[&<>]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]));

export function printWeek({ title, term, week, lessons, isPrimary }) {
  const weekDates = lessons.map((l) => l.lesson_date).filter(Boolean).sort();
  const range = weekDates.length ? `${fmtDate(weekDates[0])} – ${fmtDate(weekDates[weekDates.length - 1])}` : '';
  const cols = lessons.map((l) => {
    const parts = lessonParts(l, isPrimary).filter((p) => p.value);
    return `<td>
      <div class="day">${esc(l.day || '')} <span>${esc(fmtDate(l.lesson_date))}</span></div>
      <div class="topic">${esc(l.topic)}</div>
      <div class="unit">${esc(l.chapter || '')}${l.sections ? ` · ${esc(l.sections)}` : ''}</div>
      ${parts.map((p) => `<div class="part"><b>${esc(p.label)}</b>${esc(p.value)}</div>`).join('')}
    </td>`;
  }).join('');
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>${esc(title)} – ${esc(term)} Week ${week}</title>
<style>
  @page { size: A4 landscape; margin: 10mm; }
  body { font-family: Georgia, 'Times New Roman', serif; color: #1e293b; margin: 0; }
  h1 { font-size: 15pt; margin: 0 0 2mm; }
  .sub { font-size: 10pt; color: #475569; margin-bottom: 4mm; }
  table { width: 100%; border-collapse: collapse; table-layout: fixed; }
  td { border: 1px solid #94a3b8; vertical-align: top; padding: 2mm; font-size: 8pt; line-height: 1.25; }
  .day { font-weight: bold; text-transform: uppercase; font-size: 8pt; color: #0f766e; }
  .day span { font-weight: normal; text-transform: none; color: #64748b; }
  .topic { font-weight: bold; font-size: 10pt; margin: 1mm 0; }
  .unit { color: #64748b; font-size: 7.5pt; margin-bottom: 1.5mm; }
  .part { margin-top: 1.5mm; }
  .part b { display: block; font-size: 7pt; text-transform: uppercase; letter-spacing: .03em; color: #334155; }
  .foot { margin-top: 3mm; font-size: 7.5pt; color: #64748b; display: flex; justify-content: space-between; }
</style></head><body>
  <h1>${esc(title)}</h1>
  <div class="sub">${esc(term)} · Week ${week}${range ? ` · ${esc(range)}` : ''}</div>
  <table><tr>${cols}</tr></table>
  <div class="foot"><span>Teacher: ____________________</span><span>Class: ____________</span><span>Penama Education Portal</span></div>
  <script>window.onload = function () { window.print(); };</script>
</body></html>`;
  const w = window.open('', '_blank');
  if (!w) return false;
  w.document.open();
  w.document.write(html);
  w.document.close();
  return true;
}
